import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const PlantCtx = createContext(null);
const KEY = "eudr_plant_sel";

export function PlantProvider({ children }) {
  const { user } = useAuth();
  const [plants, setPlants] = useState([]);
  const [entities, setEntities] = useState([]);
  const [selection, setSelectionState] = useState(localStorage.getItem(KEY) || "all");

  const reload = useCallback(async () => {
    if (!user) return;
    const [p, e] = await Promise.all([api.get("/plants"), api.get("/entities")]);
    setPlants(p.data);
    setEntities(e.data);
  }, [user]);

  useEffect(() => {
    reload();
  }, [reload]);

  const setSelection = (v) => {
    localStorage.setItem(KEY, v);
    setSelectionState(v);
  };

  const params = useMemo(() => {
    if (selection.startsWith("plant:")) return { plant: selection.slice(6) };
    if (selection.startsWith("entity:")) return { entity: selection.slice(7) };
    return {};
  }, [selection]);

  const label = useMemo(() => {
    if (params.plant) return `Plant ${params.plant}`;
    if (params.entity) return entities.find((e) => e.id === params.entity)?.name || "Entity";
    return user?.role === "purchasing" ? "My plants" : "All plants";
  }, [params, entities, user]);

  return (
    <PlantCtx.Provider value={{ plants, entities, selection, setSelection, params, label, reload }}>{children}</PlantCtx.Provider>
  );
}

export const usePlant = () => useContext(PlantCtx);
